import { useSetUser, useUser } from "../../context";
import React, { useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { VStack, Text, Flex, Box } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Trans } from "react-i18next";

import { useApiTenant } from "../../context/ApiAuthContext";
import { _basePath } from "../../config";
import { imagesApiClient } from "../../apiConfig";
import AspectPhoto from "../../common/AspectPhoto";

const motionProps = {
  initial: { y: 40, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { opacity: 0, y: -80 },
  transition: {
    type: "tween",
    duration: 1,
  },
};

function Welcome() {
  const history = useHistory();
  const userData = useUser();
  // TODO: This fixes #3978, however, the response from the api should return a value we can trust and this should be removed
  const userGender = userData?.user?.gender === "Female" ? "female" : "male";
  useEffect(() => {
    setTimeout(() => {
      history.replace(`${_basePath}/appointment/checkin`);
    }, 1500);
  }, []);

  if (!userData.loggedIn) {
    return <Redirect to={_basePath} />;
  }
  return (
    <Flex
      flex={1}
      h={"100vh"}
      justifyContent={"center"}
      alignItems={"center"}
      direction={"column"}
      mx={[10, 15, 20]}
      my={0}
    >
      <VStack>
        <Box
          as={motion.div}
          key={1}
          {...motionProps}
          transition={{ delay: 0 }}
          w={"calc(100vw/6)"}
          h={"calc(100vw/6)"}
        >
          <AspectPhoto
            bg={"brand.primary.500"}
            name={`${userData?.user?.firstName} ${userData?.user?.lastName}`}
          />
        </Box>

        <motion.div key={2} {...motionProps} transition={{ delay: 0.1 }}>
          <Text
            textAlign="left"
            fontSize={["1xl", "2xl", "3xl"]}
            fontStyle="italic"
            mt="7"
          >
            <Trans i18nKey={"welcome"} context={userGender}>
              Welcome
            </Trans>
          </Text>
        </motion.div>
        <motion.div key={3} {...motionProps} transition={{ delay: 0.2 }}>
          <Text
            fontSize={["3xl", "5xl", "6xl"]}
            fontWeight="bold"
            color="brand.secondary.500"
            textAlign={"center"}
            data-testid={"welcome-user-name"}
          >
            {userData?.user?.firstName} {userData?.user?.lastName?.charAt(0)}
          </Text>
        </motion.div>
      </VStack>
    </Flex>
  );
}
export default Welcome;
